import Header from './modules/header'
import Locator from './modules/locator'
import { AjaxifyGrid_CoreInit, Form_CoreInit, Mobile, Tabs, TRANSITION_END, getCookie, setCookie } from './core'
import './plugins/forms'
import './plugins/slide-selector-menu'
import './plugins/scroll-to-anchor'
import './plugins/stick-to-container'
import './plugins/ajax-post-toolbar'
import './plugins/project-gallery'
import './plugins/compare-row'
import './plugins/stairs-effect'
import './plugins/tabs'
import './plugins/extending-list'
import './plugins/google-map'
import './plugins/carousel-arrows'

AjaxifyGrid_CoreInit()

Form_CoreInit([
  {
    classSelector: 'builder-form',
    formOptions: {
      floating_labels: true,
    },
  }
])

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    scroll: $(window).ScrollEvents(),
  }

  /* Header */
  Header.init()

  /* Locator */
  Locator.init()

  /* Job offers */
  $('.js-extending-list').each(function() {
    $(this).ExtendingList()
  })

  /* Carousel Arrows */
  $('.carousel[data-carousel*=use_arrows]').each(function() {
    $(this).CarouselArrows();
  })

  /* Forms */
  $('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })

  $('.contact-form').each(function() {
    $(this).ContactForm()
  })

  $('.application-form').each(function() {
    $(this).ApplicationForm()
  })

  $('.quote-form').each(function() {
    $(this).QuoteForm()
  })

  $('.quote-short-form').each(function() {
    $(this).QuoteShortForm()
  })

  $('.retailer-form').each(function() {
    $(this).RetailerForm()
  })

  $('.call-back-form').each(function() {
    $(this).CallBackForm()
  })

  $('.quick-lead-form').each(function() {
    $(this).QuickLeadForm()
  })

  $('.field-container--form_quote_location .select__options li').each(function() {
    $(this).RemoveNoChoice()
  })

  /* Contact map */
  $('.header__main-menu .main-menu, .header__sub-menu .main-menu').each(function() {
    $(this).slideSelectorMenu()
  })

  /* Create a menu out of titles in content */
  $('.table-of-contents a').each(function() {
    $(this).scrollToAnchor();
  })

  /* Make anchor menu stick to the left when we scroll */
  $('.js-anchor-menu').each(function() {
    $(this).stickToContainer('.js-anchor-menu-container', $('header').height() + 60);
  })

  /* Enable post toolbar */
  $('.ajax-post-toolbar').each(function() {
    $(this).ajaxPostToolbar('.ajax-post-toolbar-results', '.ajax-post-toolbar-load-more');
  })

  /* Gallery on Project page */
  $('.js-project-gallery-wrapper').each(function() {
    $(this).projectGallery();
  })

  /* Tabs */
  $('.tabs.tabs--bottom-navigation').each(function() {
    $(this).navigationAfterContent();
  });
  Tabs.init() // after navigationAfterContent

  /* Clic anchor */
  $('main a[href^="#"]').on('click', function() {
    if ($('a[name="' + $(this).attr('href').substring(1) + '"]').length) {
      let targetTop = $('a[name="' + $(this).attr('href').substring(1) + '"]').offset().top - $('.header').outerHeight(false) + 32
      $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      return false
    } else if ($($(this).attr('href')).length) {
      let targetTop = $($(this).attr('href')).offset().top - $('.header').outerHeight(false) - 32
      $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      return false
    }
  })

  /* Search */
  $('input[name="s"]').on('focus', function() {
    let searchField = $(this)
    setTimeout(function() {
      searchField.get(0).select()
    }, 25)
  })

  /* Tendances Concept Montreal only */
  $('.overlapping-stamp, .overlapping-logo').each(function() {
    $(this).closest('.text-content').css('position', 'relative');
  });

  $('.overlapping-logo').each(function() {
    $(this).closest('.text-content').addClass('overlapped-image-logo')
  });

  $('.carousel--postitem__blog_post').each(function() {
    let self = $(this)
    var col = self.closest('.col');
    if (!self.closest('.col').hasClass('col-md-12') && self.closest('.col').is(':last-child')) {
      self.closest('.row').addClass('two-columns-carousel')
      self.find('.carousel__toolbar').appendTo(self.closest('.row').find('.col').first());
    }
  });

  $('.pull-image, .pull-up').each(function() {
    let self = $(this)
    self.closest('.page-section').addClass('overflow-visible');
  });

  $('.picture-pull-down').each(function() {
    let self = $(this)
    var padding_top = parseInt(self.css('padding-top')) * 100 / self.width()
    self.wrap('<div class="picture-pull-down-wrapper" style="--padding-top:'+padding_top+'%;"></div>')
    self.closest('.page-section').addClass('overflow-visible');

  });

  /* Close popup */
  if (getCookie('popup-displayed') != 'yes') {
    setCookie('popup-displayed', 'yes', 60*60*24)
    $('.popup').each(function() {
      let $popup = $(this)
      $popup.attr('aria-hidden', 'false')
      $popup.find('.popup__close').on('click', function() {
        $popup.attr('aria-hidden', 'true')
      })
    })
  }

  /* Contact map */
  $('.contact-map').each(function() {
    $(this).ContactMap()
  })
})
